import { render, staticRenderFns } from "./M2hNews.vue?vue&type=template&id=26df904a&scoped=true&"
import script from "./M2hNews.vue?vue&type=script&lang=js&"
export * from "./M2hNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26df904a",
  null
  
)

export default component.exports